










  import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'SkeletonLoader',
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
    animation: {
      type: [String, Boolean],
      default: 'shimmer',
    },
    width: {
      type: String,
      default: '',
    },
    skeletonHeight: {
      type: String,
      default: '',
    },
    margin: {
      type: String,
      default: '0 0 1em 0',
    },
    radius: {
      type: String,
      default: '4px',
    },
    skeletonClass: {
      type: String,
      default: '',
    },
    skeletonAspectRatio: {
      type: String,
      default: '',
    },
    skeletonMaxHeight: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const componentClass = computed(() => [
      'skeleton',
      props.skeletonClass,
      props.animation ? `skeleton--${props.animation}` : null,
    ]);

    const componentStyle = computed(() => ({
      width: props.width || undefined,
      height: props.skeletonHeight || undefined,
      borderRadius: props.radius,
      margin: props.margin,
      aspectRatio: props.skeletonAspectRatio || undefined,
      maxHeight: props.skeletonMaxHeight || undefined,
    }));

    return {
      componentClass,
      componentStyle,
    };
  },
});
